import {
  CDS_CATEGORIES,
  DISCOVER_BY_FILTERS,
  Integration,
  INTEGRATIONS,
  INTEGRATIONS_CATEGORIES,
  INTEGRATION_TYPE,
} from './types';
import { productFeature } from 'lib/utils/productFeature';

export interface IntegrationResponse {
  integrationDetails: Integration[];
  integrations: { [key: string]: string };
  filters: { [key: string]: string };
  cdsCategories: { [key: string]: string };
  categories: { [key: string]: string };
}

const AWS_THUMBNAIL_PREFIX =
  'https://covideosystems.s3.amazonaws.com/integrationLogos/';

export const GMAIL_INSTALL_LINK =
  'https://chromewebstore.google.com/detail/video-screen-recorder-for/hpinghefcjjgfegpbpcigbgcdmboadjc';
export const LINKEDIN_INSTALL_LINK =
  'https://chromewebstore.google.com/detail/video-screen-recorder-for/hpinghefcjjgfegpbpcigbgcdmboadjc ';
export const LINKEDIN_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/5166997-add-covideo-to-your-linkedin-account';
export const OFFICE365_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/4967720-how-to-use-covideo-in-office-365';
export const ZOOM_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/5645195-set-up-the-covideo-for-zoom-integration';
export const SALESFORCE_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/4859415-how-to-use-the-covideo-salesforce-integration';
export const OFFICE_365_HELP_DESK_LINK =
  'https://appsource.microsoft.com/en-us/product/office/WA200002558?tab=Overview';
export const IOS_URL = 'https://apps.apple.com/us/app/covideo/id507458417';
export const MOBILE_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/4558211-how-do-i-install-the-covideo-mobile-app';
export const MOBILE_FAQ =
  'https://support.covideo.com/en/collections/1379143-mobile-app';
export const ANDROID_INSTALL_LINK =
  'https://play.google.com/store/apps/details?id=covideo.com&feature=nav_result#?t=W251bGwsMSwyLDNd';
export const ELEAD_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/5397722-how-to-use-the-covideo-elead-integration';
export const IPACKET_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/5554151-how-to-use-the-covideo-ipacket-integration';
export const WHEELSTV_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/4612493-how-to-use-wheelstv-video-content-in-covideo';
export const VIN_SOLUTIONS_HELP_DESK_LINK =
  'https://support.covideo.com/en/articles/5708074-how-to-use-the-covideo-and-vinsolutions-integration';

export const INTEGRATION_DETAILS_LIST: Integration[] = [
  {
    name: INTEGRATIONS.GMAIL,
    key: 'gmail',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
      links: {
        paragraph2: GMAIL_INSTALL_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}gmail.png`,
    productFeatureId: productFeature.GMAIL_INTEGRATION,
    thumbnail: 'https://images.covideo.com/thumbnails/gmail_integration.png',
    videoSource: 'https://videos.covideo.com/website/gmail_integration.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.COMMUNICATIONS],
  },
  {
    name: INTEGRATIONS.LINKEDIN,
    key: 'linkedIn',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3', 'paragraph4'],
      links: {
        paragraph3: LINKEDIN_HELP_DESK_LINK,
        paragraph4: LINKEDIN_INSTALL_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}linkedin.webp`,
    productFeatureId: productFeature.LINKEDIN,
    thumbnail:
      'https://covideosystems.s3.amazonaws.com/thumbnails/LinkedInIntegration.png',
    videoSource:
      'https://videos.covideo.com/videos/59777_3_23q42qgv87j1631813018.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.SOCIAL],
  },
  {
    name: INTEGRATIONS.OFFICE_365,
    key: 'office',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph3: OFFICE365_HELP_DESK_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}office-365.png`,
    thumbnail:
      'https://images.covideo.com/thumbnails/office_365_integration.png',
    videoSource:
      'https://videos.covideo.com/videos/71305_3_q29w1p3fkhf1620740226.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.COMMUNICATIONS],
  },
  {
    name: INTEGRATIONS.ZOOM,
    key: 'zoom',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph3: ZOOM_HELP_DESK_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}zoom-logo.svg`,
    thumbnail: 'https://images.covideo.com/thumbnails/zoom_integration.png',
    videoSource: 'https://videos.covideo.com/website/zoom_integration.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.COMMUNICATIONS],
  },
  {
    name: INTEGRATIONS.FACEBOOK,
    key: 'facebook',
    description: { paragraphs: ['paragraph1'] },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}facebook.webp`,
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.SOCIAL],
  },
  {
    name: INTEGRATIONS.YOUTUBE,
    key: 'youtube',
    description: {
      paragraphs: ['paragraph1'],
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}youtube.webp`,
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.SOCIAL],
  },
  {
    name: INTEGRATIONS.IOS,
    key: 'ios',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph2: MOBILE_HELP_DESK_LINK,
        paragraph3: MOBILE_FAQ,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}apple-black-logo.png`,
    thumbnail: 'https://images.covideo.com/thumbnails/mobile_integration.png',
    videoSource: 'https://videos.covideo.com/website/mobile_integration.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.COMMUNICATIONS],
  },
  {
    name: INTEGRATIONS.ANDROID,
    key: 'android',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph2: MOBILE_HELP_DESK_LINK,
        paragraph3: MOBILE_FAQ,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}android-logo.png`,
    thumbnail: 'https://images.covideo.com/thumbnails/mobile_integration.png',
    videoSource: 'https://videos.covideo.com/website/mobile_integration.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.COMMUNICATIONS],
  },
  {
    name: INTEGRATIONS.SALESFORCE,
    key: 'salesforce',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph3: SALESFORCE_HELP_DESK_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}Salesforce.png`,
    thumbnail:
      'https://images.covideo.com/thumbnails/SalesforceIntegration_Thumbnail.png',
    videoSource:
      'https://d2k7766kmw4j3n.cloudfront.net/website/SalesforceIntegration.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
  },
  {
    name: INTEGRATIONS.IPACKET,
    key: 'iPacket',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph3: IPACKET_HELP_DESK_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}iPacketLogoLarge.png`,
    productFeatureId: productFeature.IPACKET,
    thumbnail:
      'https://covideosystems.s3.amazonaws.com/thumbnails/71305_3_8eegw8xomt1631124108_0001.png',
    videoSource:
      'https://videos.covideo.com/videos/71305_3_byp1k3tbcz1669919304.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [
      CDS_CATEGORIES.VEHICLE_PRESENTATION,
      CDS_CATEGORIES.CONTENT,
      CDS_CATEGORIES.INVENTORY,
      DISCOVER_BY_FILTERS.FEATURED,
    ],
  },
  {
    name: INTEGRATIONS.CDK,
    key: 'cdk',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
    },
    productFeatureId: productFeature.ELEAD_INTEGRATION,
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM, DISCOVER_BY_FILTERS.FEATURED],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}cdk.jpg`,
  },
  {
    name: INTEGRATIONS.PROMAX,
    key: 'promax',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}proMax.webp`,
  },
  {
    name: INTEGRATIONS.TMS,
    key: 'tms',
    description: { paragraphs: ['paragraph1', 'paragraph2'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}tms.webp`,
  },
  {
    name: INTEGRATIONS.AUTOMINER,
    key: 'autominer',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [
      CDS_CATEGORIES.DATA,
      INTEGRATIONS_CATEGORIES.MARKETING,
      DISCOVER_BY_FILTERS.FEATURED,
    ],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autoMiner.webp`,
  },
  {
    name: INTEGRATIONS.EDEALER,
    key: 'edealer',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}edealer.webp`,
  },
  {
    name: INTEGRATIONS.AUTO_SWEET,
    key: 'autoSweet',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autoSweet.webp`,
  },
  {
    name: INTEGRATIONS.PREDIAN,
    key: 'predian',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}predian.webp`,
  },
  {
    name: INTEGRATIONS.DEALER_INSPIRE,
    key: 'dealerInspire',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealerInspire.webp`,
  },
  {
    name: INTEGRATIONS.HOMENET,
    key: 'homenet',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}homeNet.webp`,
  },
  {
    name: INTEGRATIONS.WHEELS_TV,
    key: 'wheelsTV',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3'],
      links: {
        paragraph3: WHEELSTV_HELP_DESK_LINK,
      },
    },
    videoSource:
      'https://videos.covideo.com/videos/71305_3_7xkp2xad461669919301.mp4',
    thumbnail:
      'https://images.covideo.com/thumbnails/71305_3_7xkp2xad461669919301_0001.png',
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY, CDS_CATEGORIES.CONTENT],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}wheelsTv.webp`,
  },
  {
    name: INTEGRATIONS.PODIUM,
    key: 'podium',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}podiumTest.png`,
    show: [INTEGRATION_TYPE.AUTOMOTIVE, INTEGRATION_TYPE.UNIVERSAL],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
  },
  {
    name: INTEGRATIONS.ELEMENT_451,
    key: 'element451',
    description: { paragraphs: ['paragraph1', 'paragraph2'] },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}Element451.png`,
    productFeatureId: productFeature.ELEMENT451_INTEGRATION,
    thumbnail:
      'https://images.covideo.com/thumbnails/71305_3_skdzlktmb31634912808_0001.png',
    videoSource:
      'https://videos.covideo.com/videos/71305_3_skdzlktmb31634912808.mp4',
    show: [INTEGRATION_TYPE.UNIVERSAL],
    categories: [
      INTEGRATIONS_CATEGORIES.CRM,
      INTEGRATIONS_CATEGORIES.MARKETING,
    ],
  },
  {
    name: INTEGRATIONS.CREDIT700,
    key: '700Credit',
    description: { paragraphs: ['paragraph1'] },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}700credit.webp`,
    thumbnail: '',
    videoSource: '',
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.FINANCE],
  },
  {
    name: INTEGRATIONS.DEALERSOCKET,
    key: 'dealersocket',
    description: {
      paragraphs: ['paragraph1', 'paragraph2', 'paragraph3', 'paragraph4'],
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealersocket.png`,
    productFeatureId: productFeature.DEALERSOCKET_INTEGRATION,
    thumbnail: '',
    videoSource:
      'https://videos.covideo.com/videos/71305_3_omlgq0sytg1671199780.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
  },
  {
    name: INTEGRATIONS.VIN_SULUTIONS,
    key: 'vinsolutions',
    description: {
      paragraphs: ['paragraph1', 'paragraph2'],
      links: {
        paragraph2: VIN_SOLUTIONS_HELP_DESK_LINK,
      },
    },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}vinSolutions.webp`,
    productFeatureId: productFeature.VIN_SOLUTIONS,
    thumbnail:
      'https://images.covideo.com/thumbnails/71305_3_tppn4s0ebj1642096847_0001.png',
    videoSource:
      'https://videos.covideo.com/videos/71305_3_tppn4s0ebj1642096847.mp4',
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM, CDS_CATEGORIES.INVENTORY],
  },
  {
    name: INTEGRATIONS.VAUTO,
    key: 'vauto',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}vAuto.webp`,
  },
  {
    name: INTEGRATIONS.DEALERSLINK,
    key: 'dealerslink',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealersLink.webp`,
  },
  {
    name: INTEGRATIONS.JD_POWER,
    key: 'jdpower',
    description: { paragraphs: ['paragraph1'] },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}jdpower.png`,
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
  },
  {
    name: INTEGRATIONS.AUTO_VERIFY,
    key: 'autoverify',
    description: { paragraphs: ['paragraph1'] },
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autoverify.png`,
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
  },
  {
    name: INTEGRATIONS.INVENTORY_PLUS,
    key: 'inventoryplus',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}inventoryplus.png`,
  },
  {
    name: INTEGRATIONS.ACV_MAX,
    key: 'acvmax',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}acvMax.webp`,
  },
  {
    name: INTEGRATIONS.VIN_CUE,
    key: 'vincue',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}vinCue.webp`,
  },
  {
    name: INTEGRATIONS.AUTO_REVOLUTION,
    key: 'autorevolution',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autoRevolution.webp`,
  },
  {
    name: INTEGRATIONS.DEALER_CENTER,
    key: 'dealerCenter',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealerCenter.webp`,
  },
  {
    name: INTEGRATIONS.DEALER_CLOUD,
    key: 'dealerCloud',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealerCloud.webp`,
  },
  {
    name: INTEGRATIONS.DEALER_COM,
    key: 'dealerCom',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealerCom.webp`,
  },
  {
    name: INTEGRATIONS.LESA,
    key: 'lesa',
    description: { paragraphs: ['paragraph1', 'paragraph2'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY, CDS_CATEGORIES.CONTENT],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}lesa.webp`,
  },
  {
    name: INTEGRATIONS.VINMOTION,
    key: 'vinmotion',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}vinMotion.webp`,
  },
  {
    name: INTEGRATIONS.DEALER_CAR_SEARCH,
    key: 'dealercarsearch',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealerCarSearch.webp`,
  },
  {
    name: INTEGRATIONS.CARS_FOR_SALE,
    key: 'carsforsale',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}carsForSale.webp`,
  },
  {
    name: INTEGRATIONS.MOMENTUM,
    key: 'momentum',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [INTEGRATIONS_CATEGORIES.CRM],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}momentum.png`,
  },
  {
    name: INTEGRATIONS.NETLOOK,
    key: 'netlook',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}netlook.png`,
  },
  {
    name: INTEGRATIONS.DEALER_EPROCESS,
    key: 'dealereprocess',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealereprocess.png`,
  },
  {
    name: INTEGRATIONS.DEALERCUE,
    key: 'dealercue',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealercue.png`,
  },
  {
    name: INTEGRATIONS.ASTRAWEB,
    key: 'astraweb',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}astraweb.png`,
  },
  {
    name: INTEGRATIONS.DEALERSYNC,
    key: 'dealersync',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealersync.png`,
  },
  {
    name: INTEGRATIONS.SINCRO,
    key: 'sincro',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}sincro.png`,
  },
  {
    name: INTEGRATIONS.AGENCY_360,
    key: 'agency360',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}360agency.png`,
  },
  {
    name: INTEGRATIONS.CARPRAZE,
    key: 'carpraze',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}carpraze.png`,
  },
  {
    name: INTEGRATIONS.DEALPACK,
    key: 'dealpack',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}dealpack.png`,
  },
  {
    name: INTEGRATIONS.AUTOTRADER,
    key: 'autotrader',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autoTrader.png`,
  },
  {
    name: INTEGRATIONS.AUTO_VISION,
    key: 'autovision',
    description: {
      paragraphs: ['paragraph1'],
    },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}autovision.png`,
  },
  {
    name: INTEGRATIONS.NEXTEPPE,
    key: 'nexteppe',
    description: { paragraphs: ['paragraph1'] },
    show: [INTEGRATION_TYPE.AUTOMOTIVE],
    categories: [CDS_CATEGORIES.INVENTORY],
    imgSrc: `${AWS_THUMBNAIL_PREFIX}nexteppe.png`,
  },
];

export const IntegrationsData = {
  integrationDetails: INTEGRATION_DETAILS_LIST,
  integrations: INTEGRATIONS,
  cdsCategories: CDS_CATEGORIES,
  categories: INTEGRATIONS_CATEGORIES,
  filters: DISCOVER_BY_FILTERS,
};
